<div *ngIf="!reloading; else showProgressView">
    <ng-content *ngIf="!initializing"></ng-content>
    <div *ngIf="loading || initializing" class="loader-container">
        <div class="inline-loader"></div>
    </div>
    <span *ngIf="loading" class="loader-text">{{ loadingText }}</span>
</div>

<ng-template #showProgressView>
    <app-infinite-progress [inProgress]="true" [label]="reloadingText"></app-infinite-progress>
</ng-template>
